import { render, staticRenderFns } from "./ScheduleNotificationTypeForm.vue?vue&type=template&id=04f3a89e&scoped=true&"
import script from "./ScheduleNotificationTypeForm.vue?vue&type=script&lang=js&"
export * from "./ScheduleNotificationTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleNotificationTypeForm.vue?vue&type=style&index=0&id=04f3a89e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3a89e",
  null
  
)

export default component.exports